import PageContainer from "../../containers/PageContainer";
import Form from "../../form/Form";
import {useNavigate} from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Button from "../../button/Button";
import {useState} from "react";
import Alert from "../../../helpers/Alert";
import AdminContainer from "../../containers/AdminCointainer";
export type IFormLayout = {
    children: React.ReactNode;
    title: string;
    urlReturn: string;
    state: any;
    setState?: any;
    apiData?: any;
    defaltValues?: any;
    onSubmit?: () => void;
    onDelete?: () => void;
}
export default function FormLayout({
    children,
    title,
    urlReturn,
    state,
    setState,
    apiData,
    defaltValues,
    onSubmit,
    onDelete,
}:IFormLayout){
    const navigate = useNavigate();
    const [loadBtn, setLoadBtn] = useState(false);
    async function onSubmitForm(){

        setLoadBtn(true);

        if (onSubmit) {
            onSubmit();
            setLoadBtn(false);
            return;
        }

        if (apiData) {
            const {data, isError} = state.id ?
                await apiData.update(state.id, state)
                : await apiData.create(state);

            if (isError){
                if (typeof data === 'object') {
                    setLoadBtn(false);
                    Object.keys(data).forEach(function(key, index) {
                        Alert.error(data[key][0]);
                    });
                    return;
                }
                setLoadBtn(false);
                return Alert.error(data.message? data.message : data);
            }
            setLoadBtn(false);

            Alert.success(state.id ? 'Editado com sucesso' : 'Salvo com sucesso');

            setTimeout(function() {
                navigate(urlReturn)
            }, 3000);
        }
    }

    const newData = () => {
        /*if (functionNewData){
            functionNewData()
        }*/
        setState(defaltValues)
        const newUrl = urlReturn.split('/');

        navigate('/'+newUrl[1]+'/formulario');
    }

    const onDeleteForm = async () => {

        const confirm = await Alert.confirm(
            'Tem certeza que deseja excluir?',
            `Excluir esse dado?`
        );
        if (! confirm) return;
        setLoadBtn(true);
        if (onDelete) {
            onDelete();
            setLoadBtn(false);
            return;
        }
        if (apiData){
            const { data, isError } = await apiData.destroy(state.id);
            if (isError){
                if (typeof data === 'object') {
                    Object.keys(data).forEach(function(key, index) {
                        Alert.error(data[key][0]);
                    });
                    return;
                }

                return Alert.error(data.message? data.message : data);
            }
            setLoadBtn(false);
            Alert.success('Deletado com sucesso');

            setTimeout(function() {
                navigate(urlReturn)
            }, 3000);
        }
    }
    return(
        <AdminContainer>
            <head className={'py-5 border-b flex gap-4 '}>
                <button type={'button'} onClick={() => navigate(urlReturn)}><FaArrowLeft size={20} /></button>
                <div className={'text-xl font-bold'}>
                    {title}
                </div>
            </head>
            <Form   onSubmit={onSubmitForm}>
                <main className={'py-5'}>
                    {children}
                </main>
                <footer className={'flex gap-4 py-5 border-t '}>
                    <Button loading={loadBtn} type={'submit'} className={'w-[100px] bg-blue-700 text-white '}>
                        Salvar
                    </Button>
                    {
                        state.id && (
                            <Button loading={loadBtn} onClick={onDeleteForm} type={'button'} className={'w-[100px] bg-red-700 text-white'}>
                                Excluir
                            </Button>
                        )
                    }
                    <Button onClick={newData} type={'button'} className={'w-[100px] bg-green-700 text-white'}>
                        Novo
                    </Button>
                </footer>
            </Form>
        </AdminContainer>
    )
}